import { render, staticRenderFns } from "./betting-search.vue?vue&type=template&id=31212000&scoped=true"
import script from "./betting-search.vue?vue&type=script&lang=js"
export * from "./betting-search.vue?vue&type=script&lang=js"
import style0 from "./betting-search.vue?vue&type=style&index=0&id=31212000&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31212000",
  null
  
)

export default component.exports